import { PluginMensageriaAlmodeService } from "@/services/mensageriaAlmode/PluginMensageriaAlmodeService"
import { DisparoDeMensagemVoucherCommand } from "@/api/pluginMensageriaAlmode"
import { Inject } from "inversify-props"

export class PluginMensageriaAlmodeUseCase {
	@Inject('PluginMensageriaAlmodeServiceAdapter')
	private pluginMensageriaAlmodeService!: PluginMensageriaAlmodeService

	async enviaComprovanteDaVendaViaMensageriaAlmode(vendaId: string, novoTelefone?: string): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaComprovanteDaVendaViaMensageriaAlmode(vendaId, novoTelefone)
	}

	async enviaFechamentoDeCaixaViaMensageriaAlmode(wppFechamento: string, body: { base64: string; lojaId: string; pdvId: string }): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaFechamentoDeCaixaViaMensageriaAlmode(wppFechamento, body)
	}

	async enviaValePresenteViaMensageriaAlmode(vendaId: string): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaValePresenteViaMensageriaAlmode(vendaId)
	}

	async enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode(lojaId: string, identificador: string): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaIdentificadorDoPedidoCriadoViaMensageriaAlmode(lojaId, identificador)
	}

	async enviaLinkPagamentoAsaasViaMensageriaAlmode(lojaId: string, body: any): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaLinkPagamentoAsaasViaMensageriaAlmode(lojaId, body)
	}

	async enviaAcaoDeCashbackViaMensageriaAlmode(command: DisparoDeMensagemVoucherCommand): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviaAcaoDeCashbackViaMensageriaAlmode(command)
	}

	async enviarAvaliacaoNpsViaMensageriaAlmode(vendaId: string): Promise<void> {
		await this.pluginMensageriaAlmodeService.enviarAvaliacaoNpsViaMensageriaAlmode(vendaId)
	}
}
